import React from 'react';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS as DEFAULT_LABELS, FUNNELS } from '../../util/constants';
import BaseAgreement from '../base-agreement';
import FUND_RULES_LINKS from './links';
const TITLES = {
  ARHI: DEFAULT_LABELS.FUND_RULES_HEADING
};
const DESCRIPTIONS = {
  ARHI: DEFAULT_LABELS.FUND_RULES_DESCRIPTION
};
const arrayToSentence = array => {
  if (array.length === 0) {
    return '';
  }
  if (array.length === 1) {
    return array[0];
  }
  return `${array.slice(0, -1).join(', ')} and ${array.slice(-1)}`;
};
const FundRulesJoinAgreement = props => {
  const {
    id = 'fundRulesJoinAgreement',
    name = 'fundRulesJoinAgreement',
    funnel = FUNNELS.ARHI,
    links,
    title,
    description,
    values,
    fields,
    ...otherProps
  } = props;
  const listOfLinks = links || FUND_RULES_LINKS[funnel] || FUND_RULES_LINKS.ARHI;
  return React.createElement(BaseAgreement, {
    id: id,
    name: name,
    funnel: funnel,
    values: values,
    title: title || TITLES[funnel] || TITLES.ARHI,
    description: description || DESCRIPTIONS[funnel] || DESCRIPTIONS.ARHI,
    links: listOfLinks,
    fieldLabel: DEFAULT_LABELS.FUND_RULES_FIELD_LABEL,
    label: `I have read and agree to the ${arrayToSentence(listOfLinks.map(item => item.text))}.`,
    fields: fields,
    ...otherProps
  });
};
FundRulesJoinAgreement.defaultProps = {
  id: 'fundRulesJoinAgreement',
  name: 'fundRulesJoinAgreement'
};
const FundRulesJoinAgreementWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(FundRulesJoinAgreement, {
  ...props
}));
export default FundRulesJoinAgreementWithFunnel;